// extracted by mini-css-extract-plugin
export default {"watermark":"watermark_pdFfy","watermark-text":"watermark-text_ujX_N","watermarkText":"watermark-text_ujX_N"};